import React from "react";
import "./TextInput.css";

const TextInput = ({
	className,
	type,
	name,
	id,
	error,
	errorMessage,
	...props
}) => {
	return (
		<>
			<input
				className={`TextInput ${className}`}
				style={{ maxWidth: "520px" }}
				type={type}
				name={name}
				id={id}
				{...props}
			/>
			{error && <p className="error-text text-left text-sm">{errorMessage}</p>}
		</>
	);
};

export default TextInput;
